import {FaMicrochip, FaPencilAlt, FaTrash} from "react-icons/fa";
import {getUrl} from "../../../constants/urls";

export const inventoryListURL = getUrl("listInventory");

export const ACTIONS_LST = [
  {label: "Edit", icon: FaPencilAlt, perms: ["change_systeminventory"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_systeminventory"]},
  {
    label: "Commission Device",
    icon: FaMicrochip,
    perms: ["change_systeminventory"],
    condition: "status",
    conditionValue: "inventory",
  },
];

export const PERMS_FOR_ACTIONS = ["change_systeminventory", "delete_systeminventory"];

export const LIST_HEADERS = [
  "mac",
  "serial",
  "check_code",
  "profile",
  "status",
  "claimed_by",
  "sim_status",
  "ip_address",
  "ssh_password",
];

export const SORTABLE_FIELDS = [
  {
    label: "MAC",
    value: "mac",
  },
  {
    label: "Serial",
    value: "serial",
  },
  {
    label: "Check Code",
    value: "check_code",
  },
  {
    label: "Profile",
    value: "profile",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Is Claimed",
    value: "is_claimed",
  },
  {
    label: "Claimed By",
    value: "claimed_by",
  },
  {
    label: "Date Claimed",
    value: "date_claimed",
    type: "date",
  },
  {
    label: "SIM Status",
    value: "sim_status",
  },
  {
    label: "IP Address",
    value: "ip_address",
  },
];

const inventoryColumns = {
  MAC: "mac",
  Serial: "systemproperties__serial",
  "Check Code": "check_code",
  "Is Claimed": "is_claimed",
  "Claimed By": "claimed_by__name",
};

export const getColumnValue = (label) => {
  return inventoryColumns[`${label}`];
};
